<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-40 md-xsmall-size-100 md-medium-size-80 mx-auto">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>mail_outline</md-icon>
          </div>
          <h4 class="title">{{$lang.titles.local_change_password}}</h4>
        </md-card-header>

        <md-card-content>
          <md-field :class="{ 'md-error': !validOldPass }">
            <label>{{$lang.keys.current_password}}</label>
            <md-input v-model="oldPassword" type="password"></md-input>
          </md-field>
          <md-field :class="{ 'md-error': !validNewPass }">
            <label>{{$lang.keys.new_password}}</label>
            <md-input v-model="newPassword" type="password"></md-input>
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" @click="changePassword">{{$lang.keys.change_password}}</md-button>
        </md-card-actions>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import axios from "axios";
import { sha256 } from "js-sha256";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "snack-bar": snackBar
  },
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      validOldPass: true,
      validNewPass: true
    };
  },
  computed: {
    getAuth() {
      return this.$store.getters.getAuth;
    }
  },
  methods: {
    changePassword() {
      if (this.getAuth.id === 1) {
        if (this.oldPassword && this.newPassword) {
          if (this.oldPassword !== this.newPassword) {
            axios({
              method: "POST",
              url: this.$ENDPOINTS.API_W + "/auth/local/change-password",
              data: {
                login: this.getAuth.user,
                oldPassword: sha256.hex(this.oldPassword),
                newPassword: sha256.hex(this.newPassword)
              }
            })
              .then(response => {
                if (response.data.status === "OK") {
                  this.oldPassword = null;
                  this.newPassword = null;
                  this.validOldPass = true;
                  this.validNewPass = true;

                  this.$refs.snackbar.notify(
                    this.$lang.messages.password_successfully_changed
                  );
                }
              })
              .catch(error => {
                console.log(error);
                this.validOldPass = false;
                this.validNewPass = false;

                this.$refs.snackbar.notify(
                  this.$lang.messages.api_communication_error
                );
              });
          } else {
            this.$refs.snackbar.notify(this.$lang.messages.passwords_equal);
          }
        } else {
          this.validOldPass = this.oldPassword ? true : false;
          this.validNewPass = this.newPassword ? true : false;
        }
      }
    }
  },
  beforeDestroy() {
    this.oldPassword = null;
    this.newPassword = null;
  }
};
</script>
